export type ComponentSettings<T extends _ComponentSettings> = T;

export type _ComponentSettings = {
  permission: Permissions;
  text: Texts;
  list: Lists;
  url: Urls;
  field: Fields;
  additionalInfo: AdditionalInfo;
};

// PERMISSION

export interface Permissions {
  [name: string]: boolean;
}

// TEXT

export interface Texts {
  [name: string]: Text;
}

export interface Languages<T> {
  de: T;
  en: T;
  nl?: T;
}

export function getTranslatedText(text: Text, language: Language): string {
  const result = text[language];
  if (result == null) {
    return text.de;
  }
  return result;
}

export type Language = keyof Languages<any>;

export type Text = Languages<string>;

// URL

export interface Urls {
  [name: string]: string;
}

// LIST

export interface Lists {
  [name: string]: List;
}

export type List = string[];

export const empty: List = [];

//ADITIONAL INFO

export interface AdditionalInfo {
  [name: string]: any;
}

// FIELD

export type Fields = { [name: string]: Field };

export interface Field {
  text: Text;
  type: FieldType;
  xml?: string;
  exportLabel?: Text;
  options?: Options;
  required?: boolean;
  mutable?: boolean;
  multiple?: boolean;
  validators?: any;
  maxLength?: number;
  search?: boolean;
  displayOptionKey?: boolean;
  format?: CodeFormat;
  value?: string;
  filter?: FilterType;
  sort?: boolean;
  unit?: Text;
  unique?: boolean;
  tooltip?: Text;
  checkboxLabels?: any;
  helperText?: Text;
  rows?: number;
  regex?: string;
  short?: string;
}

export type FieldType =
  | "value"
  | "text"
  | "number"
  | "date"
  | "options"
  | "radio"
  | "checkbox"
  | "timestamp"
  | "password"
  | "data"
  | "typeahead"
  | "user-options"
  | "dateInterval"
  | "dataList"
  | "projectNumber";

export function isTextSearchType(type: FieldType) {
  switch (type) {
    case "value":
    case "text":
    case "date":
    case "timestamp":
      return true;
    default:
      return false;
  }
}

export class FieldTypes {
  static readonly value: FieldType = "value";
  static readonly text: FieldType = "text";
  static readonly number: FieldType = "number";
  static readonly date: FieldType = "date";
  static readonly options: FieldType = "options";
  static readonly radio: FieldType = "radio";
  static readonly checkbox: FieldType = "checkbox";
  static readonly timestamp: FieldType = "timestamp";
  static readonly password: FieldType = "password";
  static readonly data: FieldType = "data";
  static readonly typeahead: FieldType = "typeahead";
  static readonly userOptions: FieldType = "user-options";
  static readonly dateInterval: FieldType = "dateInterval";
  static readonly dataList: FieldType = "dataList";
  static readonly projectNumber: FieldType = "projectNumber";
}

export interface ValueFormat {
  at: number;
  digits?: number;
  length?: number;
  fixed?: boolean;
}

export interface CodeFormat {
  text: string;
  values: { [property: string]: ValueFormat };
  textInFilter?: string;
}

export type FilterType = "contains" | "startsWith";

export class FilterTypes {
  static readonly contains: FilterType = "contains";
  static readonly startsWith: FilterType = "startsWith";
}

export type Options = {
  [value: string]: Option;
};

export interface Option {
  text: Text;
  color?: string;
  impact?: string; //used for productCatgory impact value on part
  name?: string;
  value?: string;
  short?: string;
  order?: number;
}
